import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberCollection'
})
export class NumberCollectionPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    const res = [];
    let start = Math.floor(value / 10) * 10;

    if (value <= start) {
      if (value < 0) {
        return res;
      }
        start -= 10;
      }

      for (let i = start; i < value; i++) {
        res.push(i + 1);
      }
      return res;
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/d90c5bcf/0/gaia/gaia-ui-angular/src/app/pipe/number-collection.pipe.ts